module.exports = {"id":"207948","name":"Bertrand Traoré","rating":"79","photo":"./data/images/photos/4/207948.png","club":{"name":"OL","logo":"./data/images/clubs/OL.png"},"positions":["AD","BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BertrandTraore0.json
// module id = 596
// module chunks = 0